import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';

import { ISlimScrollOptions } from 'ng2-slimscroll';
import { GroupService } from './../group.service';
import { MessageEvent, SignInEvent, OpenFrameEvent, LoaderEvent, HiddenFooter, SetAllMemberCheck } from './../../shared/message.event';
import { AppService } from '../../app.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UISETTING } from './../../shared/ui-setting';
import { UtilityFunctions } from '../../shared/utility-functions';

@Component({
    selector: 'app-group-list',
    templateUrl: './group-list.component.html',
    styleUrls: ['./group-list.component.css'],
    providers: [GroupService, MessageEvent, SignInEvent, AppService, OpenFrameEvent, LoaderEvent, HiddenFooter, SetAllMemberCheck
    ]
})
export class GroupListComponent implements OnInit {
    private _router;
    private shouldSlide: boolean = false;
    private vendor;
    private divHeight = 30;
    private pagebutton = 20;
    private noGroupAvailable: boolean = true;
    private searchMember = '';
    private search;
    @ViewChild('searchInput')
    searchInputVariable: any;
    private exp;
    private message = '';
    private groupList = [];
    private selectGroupId = '';
    private recentCreatedGroup = '';
    private memberTableHeight = 55;
    private clubName = '';
    private showCheckBox = false;
    private uiSettingObj: UISETTING;
    private scrollOptions: ISlimScrollOptions;
    private height: any;
    private utilityFunctions = new UtilityFunctions();
    constructor(private router: Router, private groupService: GroupService, private appService: AppService,
        private openFrameEvent: OpenFrameEvent, private messageEvent: MessageEvent, private signInEvent: SignInEvent,
        private loaderEvent: LoaderEvent, private hiddenFooter: HiddenFooter, private setAllMemberCheck: SetAllMemberCheck) {
        this.uiSettingObj = {
            'windowHeight': window.innerHeight,
            'topNav': 56,
            'midNav': 45,
            'footer': 35,
            'container': 20
        };
       this.scrollOptions = {
           barBackground: "#343a40", barOpacity: "0.6", position: "right",
           barWidth: "6", barBorderRadius: "5",barMargin:"1px 1px",gridBackground:"#adb5bd",gridOpacity:"1",gridWidth:"4",gridBorderRadius:"10",gridMargin:"1px 2px"
        };
        this._router = router;
        this.height = (this.uiSettingObj.windowHeight - (this.uiSettingObj.topNav + this.uiSettingObj.midNav + this.uiSettingObj.container + this.uiSettingObj.footer + this.divHeight
            + this.pagebutton)) + 'px';
        this.exp = false;
    }

    ngOnInit() {
        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        this.clubName = this.vendor.clubName;
        this.getGroupList();
        let vendorObj = { vendorId: this.vendor._id };
        this.appService.getListOfGroup(vendorObj).then((result: any) => {
            if (result.status === 'SUCCESS') {
                this.groupList = result.groups;
            } else {
                this.message = CONSTANT_MESSAGES.NO_GROUP;
            }
        });

        this.emitOpenFrameEvent();
        this.emitTypeBroadcast();
        this.registerTypeBroadcast();
    }

    emitTypeBroadcast() {
        let isShow = {
            privacypolicy: true,
            support: false,
            footer: 'block'
        };
        this.signInEvent.fire('block');
        this.hiddenFooter.fire(isShow);
    }

    emitOpenFrameEvent() {
        this.openFrameEvent.fire(false);
    }

    /**
     * while menu slide left to right as well as we shift header, footer and body too by broadcaster
     */

    registerTypeBroadcast() {
        this.messageEvent.on().subscribe(message => {
            this.shouldSlide = message;
        });
    }

    onNotify() {
    }

    /**
    * Search element will expand on search icon
    */
    expand() {
        if ((this.searchMember + '').trim()) {
        } else {
            this.searchMember = '';
            this.exp = !this.exp;
        }
    }

    redirectTo(groupObj) {
        this.selectGroupId = groupObj._id;
        localStorage.setItem('recentCreatedGroupId', btoa(JSON.stringify(groupObj._id)));
        this._router.navigate(['/group']);
    }

    /**
   * Go to home screen
   */
    homeScreen() {
        this.utilityFunctions.homeScreen(this);
    }

    /**
   * Get group list by vendor
   */
    getGroupList() {
        let vendorObj = { vendorId: this.vendor._id };
        this.appService.getListOfGroup(vendorObj).then((result: any) => {
            if (result.status === 'SUCCESS') {
                this.groupList = result.groups;
                this.selectGroupId = this.groupList[0]._id;
                if (this.groupList.length > 0 && localStorage.getItem('recentCreatedGroup')) {
                    for (let group of this.groupList) {
                        if (group.name === this.recentCreatedGroup) {
                            this.selectGroupId = group._id;
                            localStorage.removeItem('recentCreatedGroup');
                        }
                    }
                }
                this.noGroupAvailable = (this.groupList.length > 0);
                if (!this.noGroupAvailable) {
                    this.message = CONSTANT_MESSAGES.NO_GROUP;
                }
            } else {
                this.message = CONSTANT_MESSAGES.NO_GROUP;
                this.noGroupAvailable = false;
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/group/group-list/group-list.component.ts